import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/utils/cn';

/** Round, icon-only button (theme toggle, share, close, menu…). */
export const IconButton = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, type, ...props }, ref) => (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={cn(
        'rounded-full p-2 text-muted-foreground transition-all hover:bg-zinc-100 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/50 dark:hover:bg-zinc-800',
        className,
      )}
      {...props}
    />
  ),
);
IconButton.displayName = 'IconButton';
